module.exports = __webpack_public_path__ + "img/syzxc02.9488cb2d.png";